import React from "react";
// import "./About.css";

function About() {
  return (
    <div className="content-container about-page">
      <h1>About Our Lineage</h1>
      <p>
        The EVOLVING BODY MIND INSTITUTE is a fully recognized 501c.3 nonprofit
        in accordance with both California State and Federal governments, doing
        business as the "EBM Kung Fu Academy". Kung Fu training is a vehicle for
        personal growth. By enduring the mental and physical rigors of Kung Fu
        training one transforms their character and physique. Through facing the
        challenges of Kung Fu training one acheives greater self knowledge and
        confidence. EBM Kung Fu Academy provides the methodical, time tested
        Kung Fu curriculum for personal growth. EBM Kung Fu dispenses with many
        of the honorifics and formalism of traditional martial arts and provides
        a down to earth, friendly environment for training. We have a "leave
        your ego at the door" approach to teaching and training. The curriculum
        of EBM consists of both internal and external Chinese martial arts
        styles. The Northern Shaolin Kung Fu, San Shou Fighting and body
        conditioning are commonly recognized as external methods. Taiji Quan,
        Xingyi Quan and Qi Gong are commonly thought of as internal training
        methods. These systems are taught as belonging to the same general
        family-- each style complementing the other. In traditional fashion, the
        external styles and body conditioning are taught first in order to
        develop a strong foundation for the internal styles. Grandmaster Wong
        Jack Man lineage's makes up the core curriculum of EBM (Northern styles
        of Kung Fu, Taiji Quan, Xingyi Quan). The Qigong, strength training,
        Taoist meditation and Lohan body conditioning are from Grandmaster Kwan
        Sai Hung's lineage. The San Shou training is a combination of
        traditional Sanda Fighting methods with Boxing, Freestyle and
        Greco-Roman Wrestling. We are forever indebted to the great masters for
        sharing their arts and lineages.
      </p>
      <hr />
      <h2>Wong Jack Man</h2>
      December 1, 1941 – December 26, 2018
      <p>
        <img
          src="/wong-sword.jpg"
          className="left"
          style={{ width: "160px" }}
          alt="Wong"
        />
        Wong Jack Man was a renowned Grandmaster of traditional Chinese Martial
        Arts, his main arts being Taijiquan, Xingyiquan, and Northern Shaolin.
        Wong was born in China and moved to San Francisco as a young man to
        begin his career teaching the arts. Wong instructed classes in
        California for the better part of five decades before retiring in 2005.
        He was a long time teacher at the Fort Mason Center in San Francisco.{" "}
        Wong's teaching style was very traditional, there was an emphasis on
        technique and internal development. Wong's form and internal power were
        unrivaled and his classes were predominantly attended by advanced
        students and teachers seeking to make breakthroughs in their
        understanding of the arts. Wong was kind and humble, and anyone who knew
        him would attest that he was a man of the highest integrity.{" "}
      </p>
      {/* <hr style={{ clear: "both" }} />
      <h2>Kwan Sai Hung</h2>
      1920 – present
      <p>
        <img src="/ksh01.png" className="left" alt="Kwan" />
        Kwan Sai Hung was born in China in 1920 to a prominent martial arts
        family. As a youth, he had opportunities to train with many great
        masters and eventually being trained as a Taoist Monk at South Peak
        Monastery, Huashan Mountain, Northern China, eventually being fully
        ordained into the Zheng-Yi Path of Taoism.
        <img src="/ksh02.png" className="right" alt="Kwan" />
        Mr. Kwan, as he liked to be called (he disdained honorifics), has lived
        an amazing life. Born in aristocracy and chosen for the spiritual path
        of asceticism in the Taoist Monastery at Huashan. Kwan trained with many
        great martial arts masters in China and even fought in combat. When he
        left China he traveled the world, studying in India, traveling through
        Europe and America, living in many cultures, and always following his
        path. Kwan has practiced his arts in relative seclusion for more than 90
        years. Kwan taught a private class in San Francisco at the Fort Mason
        Center for many years. Kwan's classes were 4 hours in duration usually
        consisting of rigorous strength training, kung fu, chi kung, and
        meditation. Kwan also taught Taoism as a holistic practice that
        encompasses diet, exercise, philosophy, meditation, asceticism and all
        aspects of one's personal affairs. Kwan is a remarkable teacher with
        unimaginable depth and insight. Kwan is also a kind and generous person
        who always seeks to help those in need.
      </p> */}
    </div>
  );
}

export default About;
